<div class="container-loading">
    <div class="back"></div>
    <div class="loader-container">
        <img src="assets/img/logo.svg" alt="logo" class="logo">
        <div class="loading-text">Cargando...</div>
    </div>
</div>


